import React from 'react';
import { useSystemEmailTemplatesList } from '../hooks/use-system-email-templates-list.js';
import SystemEmailTemplatesListPageView from './system-email-templates-list-page-view.jsx';

function SystemEmailTemplatesListPageContainer() {
  const state = useSystemEmailTemplatesList();
  return <SystemEmailTemplatesListPageView {...state} />;
}

export default SystemEmailTemplatesListPageContainer;
